export const GOOGLE_KEY = 'AIzaSyD9Vws7N_uC2Zd6znhSd83AKgLXn_kN5zU'; // NOSONAR
